(ns renolit-roofing-service.layout.form.form-item.advanced-select.entity-list
  (:require [medley.core :as medley]
            [re-frame.core :as rf]
            [renolit-roofing-service.entity-list :as entity-list]
            [renolit-roofing-service.layout.form.form-item :as form.form-item]
            [renolit-roofing-service.layout.form.form-item.advanced-select :as form-item.advanced-select]))

(rf/reg-event-fx
 ::load-initial-data
 (fn [_ [_ {:keys [entity-key entity-list-opts data-cols]}]]
   {:fx [[:dispatch [::entity-list/set-sorting entity-key
                     (:sorting entity-list-opts)]]
         [:dispatch [::entity-list/set-filters entity-key
                     (:filters entity-list-opts)]]
         [:dispatch [::entity-list/load-list
                     (medley/deep-merge
                      {:entity-key entity-key
                       :extra-params {:cols data-cols}}
                      (:load-data entity-list-opts))]]]}))

(rf/reg-event-fx
 ::load-more-data
 (fn [_ [_ {:keys [entity-key entity-list-opts data-cols]} new-page]]
   {:fx [[:dispatch [::entity-list/update-pagination entity-key
                     {:page new-page
                      :more-pages-available? nil}]]
         [:dispatch [::entity-list/load-list
                     (medley/deep-merge
                      (:load-data entity-list-opts)
                      {:entity-key entity-key
                       :keep-prv-data? true
                       :extra-params {:cols data-cols}})]]]}))

(rf/reg-event-fx
 ::on-search-changed
 (fn [_ [_ {:keys [entity-key entity-list-opts data-cols]} search-string]]
   {:fx [[:dispatch [::entity-list/update-pagination entity-key
                     {:page 0 :total-count 0}]]
         [:dispatch [::entity-list/set-filters entity-key
                     (merge
                      (:filters entity-list-opts)
                      {:search search-string})]]
         [:dispatch [::entity-list/load-list
                     (medley/deep-merge
                      (:load-data entity-list-opts)
                      {:entity-key entity-key
                       :extra-params {:cols data-cols}})]]]}))

(defn- determine-data-cols
  [opts]
  (concat
   [(get opts :choice-id-kw form-item.advanced-select/default-choice-id-kw)
    (get opts :choice-display-name-kw form-item.advanced-select/default-choice-display-name-kw)]
   (get opts :choice-extra-attr-kws)))

(defmethod form.form-item/form-item-component :advanced-select-with-entity-list
  [_opts]
  (let [entity-key [:advanced-select-with-entity-list (random-uuid)]
        choices (rf/subscribe [::entity-list/list entity-key])
        pagination (rf/subscribe [::entity-list/pagination entity-key])]
    (fn [{:keys [entity-list-opts] :as opts}]
      (let [evt-opts {:entity-key entity-key
                      :entity-list-opts entity-list-opts
                      :data-cols (determine-data-cols opts)}]
        [form.form-item/form-item-component
         (medley/deep-merge
          opts
          {:type :advanced-select
           :choices @choices
           :pagination @pagination
           :on-page-change {:evt [::load-more-data evt-opts]}
           :on-open {:evt [::load-initial-data evt-opts]}
           :on-close {:evt [::entity-list/clean-entity-data entity-key]}
           :on-search {:evt [::on-search-changed evt-opts]}})]))))
